module.exports = __webpack_public_path__ + "img/home.8e680177.png";